<template>
  <v-container class="fill-height">
    <v-col>
      <v-row align="center" justify="center">
        <v-col cols="10" sm="8" md="5" lg="4">
          <div class="mb-10">
            <img
              src="@/assets/elgin-logo.svg"
              style="width: 100%; max-height: 20px"
            />
          </div>
          <div class="text-center mb-10">
            <h2 class="text-h5 font-weight-medium mb-2">Seja bem vindo!</h2>
            <span
              >Clique no botão abaixo para fazer login com sua conta
              Veraciti.</span
            >
          </div>

          <v-btn
            color="primary"
            block
            @click="startLogin"
            :disabled="isLogging"
            size="large"
          >
            <v-icon start :icon="mdiAccount" />
            <template v-if="isLogging">
              <span>Conectando...</span>
            </template>
            <template v-else>
              <span>Entrar com Veraciti</span>
            </template>
          </v-btn>
        </v-col>
      </v-row>

      <v-col>
        <v-snackbar
          v-model="snackbar"
          :color="snackbarColor"
          :multi-line="true"
          :timeout="6000"
          :vertical="true"
        >
          {{ snackbarText }}
          <v-btn variant="text" @click="snackbar = false"> Fechar </v-btn>
        </v-snackbar>
      </v-col>
    </v-col>
  </v-container>
</template>

<script setup>
import { ref, computed, onBeforeMount } from "vue";
import { mdiAccount } from "@mdi/js";
import { useRoute, useRouter } from "vue-router";
import oauth2Service from "@/services/oauth2";
import { useAuthStore } from "@/stores/auth";

const route = useRoute();
const router = useRouter();
const authStore = useAuthStore();

const isLogging = ref(false);
const snackbarText = ref("");
const snackbar = ref(false);
const snackbarColor = ref("success");

const loggingIn = computed(() => authStore.status?.loggingIn);

const startLogin = async () => {
  isLogging.value = true;
  snackbar.value = false;

  try {
    await oauth2Service.startAuthorization();
  } catch (error) {
    console.error("Login failed:", error);
    snackbarText.value = error.message || "Falha ao iniciar login";
    snackbarColor.value = "error";
    snackbar.value = true;
    isLogging.value = false;
  }
};

onBeforeMount(() => {
  if (route.query.activation_token) {
    router.push({
      name: "account.confirmation",
      query: {
        token: route.query.activation_token,
      },
    });
  }
});
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>
